export default {"src":"/_next/static/media/flow-3.1f4242a8.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};